import _ from 'lodash';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConsultRequestService, CnsltnFwdrModel, QuotationService, PagerService, TableHeader, CommonService } from 'app/services';
import { Util } from 'app/utils';
import { Utils } from 'ag-grid';
import { Subscription } from 'rxjs';
declare var $:any;

@Component({
    selector: 'cnsltn-list-item-fwdr-list',
    templateUrl: 'cnsltn-list-item-fwdr-list.html'
})


export class CnsltnListItemFwdrListComponent {

    _reqNo:string;
    @Input() set reqNo(reqNo:string){

        if(reqNo){
            this._reqNo = reqNo;
            this.initSearch();
        }
    }

    get reqNo():string{
        return this._reqNo;
    }

    @Output() hideEe: EventEmitter<any> = new EventEmitter();

    cnsltnFwdrList:Array<CnsltnFwdrModel> = new Array();  
    filteredCnsltnFwdrList: Array<CnsltnFwdrModel> = new Array();
  
    searchText:string = '';
  
    pager: any = {};
    pagedItems: any[];

    getStusNm:Function = QuotationService.getStusNm;
    getImOrPossible:Function = QuotationService.getImOrPossible;
    phoneFormatter:Function = Util.phoneFormatter;

    headerList:Array<TableHeader> = null;
    clickedHader:TableHeader;

    searchSub:Subscription;
    headerSortedSub:Subscription;
    headerClearSub:Subscription;

    constructor( 
        private consultRequestService:ConsultRequestService,
        private quotationService:QuotationService,
        private pagerService:PagerService,
        private commonService:CommonService
    ) {
        this.headerSortedSub = commonService.headerSortedEmit.subscribe(sortedData =>{
            this.filteredCnsltnFwdrList = sortedData;
            this.setPage(1);
        });
        this.headerClearSub = commonService.clearHeaderEmit.subscribe(headers =>{
            this.headerList = headers;
        });
    }

    ngOnInit() {
        this.makeHeader();
        this.initSearch();
    }

    ngOnDestroy(){
        if(this.searchSub) this.searchSub.unsubscribe();
        if(this.headerSortedSub) this.headerSortedSub.unsubscribe();
        if(this.headerClearSub) this.headerClearSub.unsubscribe();
    }

    close() {
        this.cnsltnFwdrList = new Array();
        this.reqNo = null;
        this.hideEe.emit();
    }   

    initSearch(){
        this.searchSub = this.consultRequestService.getCnsltnFwdrList(this.reqNo).subscribe(
            resp => {
                if(resp.result) {
                    this.cnsltnFwdrList = resp.data;

                    if(this.cnsltnFwdrList){

                        this.cnsltnFwdrList = _.orderBy(this.cnsltnFwdrList, ['stusNm', 'corpNm'], ['asc', 'asc']);
    
                        this.filteredCnsltnFwdrList = this.cnsltnFwdrList;
                        this.setPage(1);
                    }
                }
            }
        );
    }

    setPage(page: number) {
        this.pager = this.pagerService.getPager(this.filteredCnsltnFwdrList.length, page, 10);
    
        // if (page < 1) {
        //   return;
        // } 
    
        this.pagedItems = this.filteredCnsltnFwdrList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    search(event) {
        var filterValue = event.target.value;
    
        this.filteredCnsltnFwdrList = _.filter(this.cnsltnFwdrList, item => {
                if (!filterValue) return true;
    
                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                console.log(filter);
                return valuesStr.indexOf(filter) >= 0;
        });
        
        this.setPage(1);
    }

    makeHeader(){
        this.headerList = new Array<TableHeader>();
        this.headerList.push(new TableHeader(0, 'corpId', 'No.', true));
        this.headerList.push(new TableHeader(1, 'stusNm', '포워더 견적 상태', true));
        this.headerList.push(new TableHeader(2, 'corpNm', '회사명', true));
        this.headerList.push(new TableHeader(3, 'managerNm', '담당자', true));
        this.headerList.push(new TableHeader(4, 'email', '이메일', true));
        this.headerList.push(new TableHeader(5, 'mobile', '연락처', true));
        this.headerList.push(new TableHeader(6, 'cnsltnImOrPossible', '견적가능여부', true));       
    }

    headerClick(header:TableHeader){
        this.clickedHader = header;
        this.commonService.headerClick(header, this.filteredCnsltnFwdrList);
    }

}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/cnsltn-list/cnsltn-list-item-fwdr-list.ts